import { Inter } from 'next/font/google'
import { useRouter } from 'next/router'
import NoVenue from '@/components/home/NoVenue'
import Venue from '@/components/home/Venue'

const inter = Inter({ subsets: ['latin'] })

export default function Home() {
  const router = useRouter()
  const { venue_uuid } = router.query
  return <main className={`${inter.className}`}>{venue_uuid ? <Venue venue_uuid={venue_uuid as string} /> : <NoVenue />}</main>
}
